import { dayjs } from '@lib/dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { companyTimeZone } from '@lib/time';

/**
 * get local date without time
 * @param date date
 * @param tz timezone
 * @returns date
 */
export const getLocalDate = (date: Date, tz = companyTimeZone): Date => {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const dayJ = dayjs(date).tz(tz);
  // console.log('original date', date, dayJ.format());
  return new Date(dayJ.format('YYYY-MM-DD'));
};

export const getAge = (date: Date) => {
  const today = new Date();
  const birthDate = new Date(date);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age -= 1;
  }
  return age;
};

export const getExpectedDobByAge = (age: number) => {
  const today = new Date();
  const year = today.getFullYear() - age;

  return dayjs().set('year', year).format('YYYY-MM-DD');
};

export const checkAgeEligibilityForPurchase = (
  dob: Date | string | dayjs.Dayjs
) => {
  dob = dayjs(dob);

  const dobLimit = getExpectedDobByAge(10);

  return !dob.isBefore(dayjs(dobLimit));
};

export const getAgeInDays = (date: any) => {
  const ageInDays = Math.trunc((Date.now() - date) / (24 * 60 * 60 * 1000));

  return ageInDays;
};

export const getAgeInWeeks = (date: number) => {
  const ageInWeeks = Math.trunc(
    (Date.now() - date) / (7 * 24 * 60 * 60 * 1000)
  );

  return ageInWeeks;
};

export const currentYear = new Date().getFullYear();

// Formats date to YYYY-mm-dd
export const formatDate = (date: Date | string): string => {
  const actualDate = typeof date === 'string' ? new Date(date) : date;
  const { year, month, day } = {
    year: actualDate.getFullYear(),
    month: `0${actualDate.getMonth() + 1}`.slice(-2),
    day: `0${actualDate.getDate()}`.slice(-2),
  };
  return `${year}-${month}-${day}`;
};

export const formatDateFromDMY = ({
  day,
  month,
  year,
}: {
  day: number;
  month: number;
  year: number;
}): string => {
  return `${year}-${month.toString().padStart(2, '0')}-${day
    .toString()
    .padStart(2, '0')}`;
};

export const roundToNextDay = (date: Date): Date => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + 1);
  return newDate;
};

export const roundAndFormatDate = (date: Date) => {
  return formatDate(roundToNextDay(date));
};

export const Months: { [key: string]: number } = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
};
